import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { useChosenLocale } from '#pplx/frontend/apps/ask/shared-ui-components/hooks/useChosenLocale.js';
import { resetChosenLocale } from '#pplx/frontend/i18n/browser.js';
import { supportedLanguages } from '#pplx/frontend/i18n/core.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { clearServiceWorkerRuntimeCache } from '#pplx/frontend/workers/service-worker/utils/clearServiceWorkerRuntimeCache.js';
import { useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
const DEFAULT_VALUE = 'default';
export const AccountMenuLanguageSubmenu = ({ onLocaleChanged, } = {}) => {
    const { $t } = useIntl();
    const router = useRouter();
    const { locale, saveLocale, hasChosenLocale } = useChosenLocale();
    const selectedValue = hasChosenLocale ? locale : DEFAULT_VALUE;
    const handleValueChange = useCallback(async (value) => {
        if (value === DEFAULT_VALUE) {
            resetChosenLocale();
            onLocaleChanged?.();
            router.refresh('Interface language reset');
            return;
        }
        saveLocale(value);
        onLocaleChanged?.();
        await clearServiceWorkerRuntimeCache();
        router.refresh('Interface language select');
    }, [onLocaleChanged, saveLocale, router]);
    const selectedLanguage = useMemo(() => {
        if (!hasChosenLocale) {
            return $t({
                defaultMessage: 'Default',
                description: 'Label shown when no custom language has been chosen',
                id: '3a2f3efbd2',
            });
        }
        const match = supportedLanguages.find((lang) => lang.locale === locale);
        return (match?.label ??
            $t({
                defaultMessage: 'Default',
                description: 'Fallback label when the selected language is not found in the options list',
                id: '94bb2617ed',
            }));
    }, [locale, hasChosenLocale, $t]);
    return (_jsx(DropdownMenu.Submenu, { triggerElement: _jsx(DropdownMenu.SubmenuItem, { leadingAccessory: $icon('language'), subtitle: selectedLanguage, children: _jsx(FormattedMessage, { defaultMessage: "Language", description: "Label for the language submenu trigger in the sidebar account menu", id: "43db9cd6f7" }) }), children: _jsxs(DropdownMenu.RadioGroup, { value: selectedValue, onValueChange: handleValueChange, children: [_jsx(DropdownMenu.RadioItem, { value: DEFAULT_VALUE, children: _jsx(FormattedMessage, { defaultMessage: "Default", description: "Option in the language submenu to use the browser default language", id: "5ac944d97d" }) }), supportedLanguages.map((lang) => (_jsx(DropdownMenu.RadioItem, { value: lang.locale, children: lang.label }, lang.locale)))] }) }));
};
//# sourceMappingURL=AccountMenuLanguageSubmenu.js.map